import { CollectionResponse, CrudService, Resource } from '@rdss/client';

@Resource('widgets/suggest')
/**
 * GlobalSearchService is a service class that extends the CrudService.
 * It is used to fetch suggestions based on a search term.
 *
 * @template Suggestions The type of the suggestions that this service returns.
 */
export class GlobalSearchService<Suggestions> extends CrudService<never, Suggestions> {

    /**
     * FindSuggestions is an async method that takes a search term as a parameter.
     * It returns a Promise that resolves to a CollectionResponse of Suggestions.
     *
     * @param {string} term - The term to search for.
     * @returns {Promise<CollectionResponse<Suggestions>>} A Promise that resolves to a CollectionResponse of Suggestions.
     */
    async findSuggestions(term: string): Promise<CollectionResponse<Suggestions>> {
        return this.find({ q: term });
    }
}
